// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1603":"npm.core-js","3773":"npm.dompurify","7383":"npm.html2canvas","8727":"npm.canvg"}[chunkId] || chunkId) + "." + {"1603":"b7123363723d5e58de71","3773":"0db497c766f0e5f0b20e","4964":"150af64d7baec9055385","7383":"4eec8d659d5b3c3ebbf7","8727":"f870bf6f0a46fa6512d2"}[chunkId] + ".js";
};